import { PayloadAction } from '@reduxjs/toolkit';
import EUserType from 'enums/userTypes';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import IAccountEditRequestBody from 'services/httpClient/requests/account/IAccountEditRequestBody';

import { authActions } from '..';

import { IAccountEditRequestAction } from '../reducers/edit/request';

function* edit(action: PayloadAction<IAccountEditRequestAction>) {
  try {
    const body: IAccountEditRequestBody = {
      email: action.payload.data.email,
      locale: action.payload.data.locale,
      firstname: action.payload.data.firstName,
      lastname: action.payload.data.lastName,
      mobile_phone: action.payload.data.gsm,
      phone: action.payload.data.fixPhoneNumber || undefined,
      password: action.payload.data.password || undefined,
    };
    const isOwner = action.payload.data.role === EUserType.Owner;

    // url changes if it's a trader (owner) or worker
    const url = isOwner
      ? `traders/v1/traders/${action.payload.data.id}`
      : `rik/v1/workers/${action.payload.data.id}`;

    if (isOwner) {
      yield call(
        httpClient.put,
        `backoffice/v1/intervention_partnerships/${action.payload.data.intervention_partnership_id}`,
        {
          trader_id: action.payload.data.id,
          first_name: action.payload.data.firstName,
          last_name: action.payload.data.lastName,
          mobile_phone: action.payload.data.gsm,
        },
      );
    }

    const { data } = yield call(httpClient.put, url, body);

    yield put(authActions.editSuccess(data));
    action.payload.functions.success();
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(authActions.editFailure());
  }
}

export default edit;
